import { useEffect, useState } from "react";
import Table from "react-bootstrap/Table";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

const EVENT_TYPE_MAP = {
  // Vayyar (Viva02P)
  calling: "Düşme Alarmı",
  inBed: "Yatağa Girme",
  "In Bed": "Yatağa Girme",
  outOfBed: "Yataktan Çıkma",
  "Out Of Bed": "Yataktan Çıkma",
  awayFromBed: "Yataktan Uzakta",
  bp: "Tansiyon Alarmı",
  rr: "Solunum Sayısı",
  hr: "Kalp Atış Hızı",
  bt: "Vücut Sıcaklığı Alarmı",
  callButton: "Aranma",
  fall: "Düşme Önleme Alarmı",
  falldetected: "Düşme Alarmı",
  "Low Heart Rate": "Düşük Kalp Atış Hızı",
  "High Heart Rate": "Yüksek Kalp Atış Hızı",
  "Low Respiration Rate": "Düşük Solunum Hızı",
  "High Respiration Rate": "Yüksek Solunum Hızı",
  head: "Epilepsi Alarmı",
  spo: "Oksijen Saturasyonu",
  tback: "Bası Yarası Hatırlatma",
  tleft: "Bası Yarası Hatırlatma",
  tright: "Bası Yarası Hatırlatma",
  "Posture Change": "Bası Yarası Hatırlatma",
  "Leave area": "Yataktan Çıkma",
  "Enter area": "Yatağa Girme",
  "Enter room": "Odaya Girme",
  "Leave room": "Odadan Çıkma",
  "Turn Resident": "Bası Yarası Hatırlatma",
  "Fall Prevention": "Düşme Önleme",
  // Viva03D
  "Suspected fall": "Şüpheli Düşme",
  "Fall confirmation": "Düşme Onayı",
  "Heart rate abnormal": "Anormal Kalp Atışı",
  "Breath rate abnormal": "Anormal Solunum",
  "No event": "Olay Yok",
  // V46 Akıllı Saat
  sos: "SOS Alarmı",
  falldown: "Düşme Alarmı",
  removewatch: "Saat Çıkarma Alarmı",
  lowbattery: "Düşük Batarya",
  heartrate_abnormal: "Anormal Kalp Atışı",
  geofence: "Güvenli Alan Dışı",
};

const CONFIRMATION_MAP = {
  true: "Teyit Edildi",
  false: "Bekliyor",
  "": "Bekliyor",
};

const LastFiveAlarm = ({ id, closeLastAlarmsModal, lat, long }) => {
  const [alarm, setAlarm] = useState([]);

  const [show, setShow] = useState(true);
  const [alarmShow, setAlarmShow] = useState(true);

  function convertDate(input) {
    if (input === null || input === undefined || input === "") return "-";
    let d;
    if (typeof input === "string" && isNaN(Number(input))) {
      // ISO veya benzeri tarih string'i
      d = new Date(input);
    } else {
      // UNIX timestamp (sn veya ms)
      let n = Number(input);
      if (isNaN(n)) return "-";
      if (n.toString().length === 10) n *= 1000;
      d = new Date(n);
    }
    if (isNaN(d.getTime())) return "-";
    return d.toLocaleString("tr-TR", {
      timeZone: "Europe/Istanbul",
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  }

  async function getAlarmDetail() {
    try {
      const response = await fetch(`https://app.vivasmartcare.com/api/alarm-detail/${id}`);
      const data = await response.json();
      // En son alınan 5 alarm (createdAt/endTimestamp desc)
      const getTime = (a) => {
        const t = a.createdAt || a.endTimestamp;
        const d = t ? new Date(t).getTime() : 0;
        return isNaN(d) ? 0 : d;
      };
      const sorted = [...data].sort((a, b) => getTime(b) - getTime(a));
      setAlarm(sorted.slice(0, 5));
    } catch (error) {
      console.error("Veri getirilirken bir hata oluştu:", error);
    }
  }

  useEffect(() => {
    console.log(id);
    getAlarmDetail();
  }, [id]);

  if (alarm.length < 1)
    return (
      <Modal show={show}>
        <Modal.Header>Alarm Kaydı Bulunamadı</Modal.Header>
        <Modal.Body className="device-add-wrapper">
          <p>Bu cihaza ait herhangi bir alarm kaydı bulunamadı!</p>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => setShow(false)}>Kapat</Button>
        </Modal.Footer>
        {lat !== null && long !== null && (
          <iframe
            src={`https://maps.google.com/?q=${lat},${long}`}
            width="100%"
            height="400"
            allowFullScreen
            contextMenu=","
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        )}
      </Modal>
    );

  return (
    <Modal show={alarmShow}>
      <Modal.Header>Son Alınan Alarmlar</Modal.Header>
      <Modal.Body>
        <Table striped bordered hover responsive className="alarm-table">
          <thead>
            <tr>
              <th>Alarm Tipi</th>
              <th>Açıklama</th>
              <th>Teyit Durumu</th>
              <th>Tarih</th>
            </tr>
          </thead>
          <tbody>
            {alarm?.map((detail, index) => (
              <tr key={index}>
                <td>{EVENT_TYPE_MAP[detail.eventType] || detail.eventType || "-"}</td>
                <td>{detail.description || "-"}</td>
                <td>
                  {CONFIRMATION_MAP[String(detail.confirmation)] ??
                    (detail.confirmation || "-")}
                </td>
                <td>{convertDate(detail.createdAt || detail.endTimestamp)}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={closeLastAlarmsModal}>Kapat</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default LastFiveAlarm;
